import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import item from '@/pages/item'
import itemvoice from '@/pages/itemvoice'
import brand from '@/pages/brand'
import brandvoice from '@/pages/brandvoice'
import coral from '@/pages/coral'
import coralvoice from '@/pages/coralvoice'
import link from '@/pages/link'
import error from '@/pages/error'
import nav from '@/components/nav'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/nav',
      name: 'nav',
      component: nav
    },
    {
      path: '/item',
      name: 'item',
      component: item
    },
    {
      path: '/item/:id',
      name: 'itemvoice',
      component: itemvoice
    },
    {
      path: '/brand',
      name: 'brand',
      component: brand
    },
    {
      path: '/brand/:id',
      name: 'brandvoice',
      component: brandvoice
    },
    {
      path: '/coral',
      name: 'coral',
      component: coral
    },
    {
      path: '/coral/:id',
      name: 'coralvoice',
      component: coralvoice
    },
    {
      path: '/link',
      name: 'link',
      component: link
    },
    {
      path: '*',
      name: 'error',
      component: error
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js